import { render, staticRenderFns } from "./index-services.vue?vue&type=template&id=24653180&"
import script from "./index-services.vue?vue&type=script&lang=js&"
export * from "./index-services.vue?vue&type=script&lang=js&"
import style0 from "./index-services.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports